/**
 * Ryan O'Dowd
 * 2025-06-12
 * © Copyright 2025 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import React from 'react';
import Text from '@components/common/Text';
import {
  View,
} from 'react-native';
import getStyles from './styles';
import hooks from '@hooks';

const FormLabel = (props: FormLabelProps) => {
  const styles = hooks.useStyles(getStyles);

  return (
    <View style={[styles.container, props.isAlert && styles.containerAlert]}>
      {typeof props.children === 'string'
        ? <Text style={styles.labelText}>{props.children}</Text>
        : props.children
      }
    </View>
  );
};

class FormLabelProps {
  children: React.ReactNode;

  isAlert?: boolean;
};

FormLabel.displayName = 'FormLabel';
export default FormLabel;
